import React from 'react';
import TalkToExpert from '../../components/TalkToExpert';
import '../ServicePage.css';

const ServerManagement = () => {
  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Server Management</h1>
            <p className="service-description">
              Comprehensive server management services to ensure optimal performance, 
              security, and reliability of your critical business systems.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="service-details">
              <h2>Server Management Solutions</h2>
              
              <div className="service-features">
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">📊</div>
                    <h3>Server Monitoring</h3>
                  </div>
                  <p>8 X 6 monitoring of server performance, resource utilization, and system health.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔄</div>
                    <h3>Backup Management</h3>
                  </div>
                  <p>Automated backup solutions with regular testing and disaster recovery planning.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">🔒</div>
                    <h3>Security Management</h3>
                  </div>
                  <p>Server security hardening, patch management, and vulnerability assessments.</p>
                </div>
                
                <div className="feature-item">
                  <div className="feature-header">
                    <div className="feature-icon">⚡</div>
                    <h3>Performance Optimization</h3>
                  </div>
                  <p>Server performance tuning and optimization for maximum efficiency and speed.</p>
                </div>
              </div>

              <div className="benefits-section">
                <h2>Management Benefits</h2>
                <ul className="benefits-list">
                  <li>✓ 99.9% server uptime guarantee</li>
                  <li>✓ Proactive issue prevention</li>
                  <li>✓ Automated monitoring and alerts</li>
                  <li>✓ Regular performance reports</li>
                  <li>✓ Scalable management solutions</li>
                  <li>✓ Certified server administrators</li>
                </ul>
              </div>
            </div>

            <div className="service-sidebar">
              <div className="service-card">
                <h3>Service Highlights</h3>
                <div className="highlight-item">
                  <span className="highlight-label">Uptime:</span>
                  <span className="highlight-value">99.9%</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Monitoring:</span>
                  <span className="highlight-value">8 X 6</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Backup:</span>
                  <span className="highlight-value">Automated</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-label">Certification:</span>
                  <span className="highlight-value">MCSE</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <TalkToExpert />
    </div>
  );
};

export default ServerManagement;
